import classNames from 'classnames';
import PentiaLogo from 'ui/icons/pentia_logo_bookmark.svg';
import KpLogo from 'ui/icons/klausenpartners_logo.svg';
import styles from './Logo.module.scss';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { GLOBAL_THEMES, GLOBAL_THEME_DEFAULT } from '_constants';
import { UI_Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';

export interface UI_LogoProps {
	className?: string;
	headingSlug?: string;
}

export const UI_Logo: React.FC<UI_LogoProps> = ({ className, headingSlug = GLOBAL_THEME_DEFAULT }) => {
	return (
		<UI_Link className={classNames(styles.Logo, className)} href="/">
			<UI_Paragraph className={styles.Logo_heading}>{GLOBAL_THEMES.find((theme) => theme.slug === headingSlug).name}</UI_Paragraph>
			<UI_Icon className={styles.Logo_asset} size="auto">
				{headingSlug === 'kogp' && <KpLogo />}
				{(headingSlug === 'pentia-dk' || headingSlug === 'pentia-se') && <PentiaLogo />}
			</UI_Icon>
		</UI_Link>
	);
};
